const WS_SERVER = 'wss://dlab.u-aizu.ac.jp/status'

const createConnection = () => {
  return new WebSocket(WS_SERVER)
}

export default createConnection
